import React from "react";

const UKsNo1 = () => {
  return (
    <div
      className={
        "inline-flex justify-center items-center gap-1 border border-[#A9E2AC] bg-[#ECF9ED] px-2 py-1 rounded-md border-solid font-jost"
      }>
      <img
        src="/assets/images/house-competition/tabler-icon-discount-check-filled.svg"
        alt="UK's No.1"
        className="w-6 h-6 shrink-0 aspect-[1/1]"
      />
      <span className={"text-[#256929] text-center text-lg font-normal leading-6"}>UK’s No.1 – Over 525k Winners</span>
    </div>
  );
};

export default UKsNo1;
